export default "__VITE_ASSET__60efe9fd__"